import * as React from "react";

export class ErrorsAndWarnings
{
    private static readonly style: any = {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        left: '20px',
        right: '20px',
        bottom: '20px',
        top: '20px',
        verticalAlign: 'middle',
        color: '#FF6600',
        listStylePosition: 'inside',
    };

    private static readonly innerStyle: any = {
        display: 'flex',
        flexFlow:'column',
        margin: 'auto',
        maxWidth:'50%',
        background: '#FFFFFF',
        padding: '20px',
        zIndex:50,
        fontSize:'20px',
    };


    static displayError(headline: string, message: JSX.Element[]): JSX.Element
    {
        return <div className={'renderer-error'} style={this.style}>
            <div style={this.innerStyle}>
                <h2>{headline}</h2>
                {message}
            </div>
        </div>;
    }

    static displayRenderNotFound(rendererType: string, supportedRenderers: string[]): JSX.Element
    {
        supportedRenderers.sort();
        const lis: JSX.Element[] = supportedRenderers.map((item: string, index: number) =>
        {
            return <li key={index}>{item}</li>
        });

        return this.displayError(
            "No render found for page type: '" + rendererType + "'!",
            [<p key={'message'}>Supported renderers are:</p>, <ul key={'list'}>{lis}</ul>]
        );
    }

    static displayRenderError(headline: string, property: string, error: any, data:any=null): JSX.Element
    {
        return this.displayError(
            headline,
            [<p key={'message'}>Error occurred when reading property {property}</p>,
                <p key={'error'}>Error Message:<br/>{error.toString()}</p>,
                <p key={'hint'}>Please check your data xml node for current page.</p>,
                <p key={'hint'}>{JSON.stringify(data)}</p>]
        );
    }
}